'use strict';

var _ = require('lodash');
var validate_cb_1ormore = require('../common/validate-checkables-atleastone');
var validate_textfield = require('../common/validate-textfield');
var numeral = require('numeral');
require('../common/trim');
const paymentGateway = require('../common/payment-gateway');

module.exports = {
	init: function () {
		window.jQuery('#address1,#address2,#city,#state,#postalCode,#nation').keyup(updateAddress).change(updateAddress);
	},
	configureDesignationSearch: function () {
		window.jQuery('.giftDesignation').change(handleDesignationChange);
		handleDesignationChange();

		window
			.jQuery('.designationSearch')
			.typeahead({
				source: searchDesignations,
				autoSelect: true,
				afterSelect: function (designation) {
					setOtherDesignation(designation);
				},
				matcher: function () {
					// we're taking care of this on the api, so just true
					return true;
				}
			})
			.on('blur', function () {
				setTimeout(function () {
					if (window.jQuery('#giftDesignation_other').val() === '') {
						window.jQuery('.designationSearch').val('');
					}
				}, 150);
			});

		window.jQuery('.researchOtherDesignation').on('click', function () {
			clearOtherDesignation();
			handleDesignationChange();
		});
	},
	handleGiftChange: function giftChangeHandler() {
		if (window.jQuery('#giftDollars').length === 0) {
			return;
		}
		// strip invalid characters from gift amount
		var giftDollars = window.jQuery('#giftDollars').val() || '0';
		giftDollars = giftDollars.replace(/[^0-9\.]+/g, '');

		var minGiftDollars = window.iq.minGiftDollars;
		if (
			giftDollars !== '' &&
			giftDollars !== '0' &&
			giftDollars !== '0.00' &&
			giftDollars !== 0 &&
			parseFloat(giftDollars) < minGiftDollars
		) {
			window.jQuery('#giftDollars').val(giftDollars);
			window.jQuery('#minGiftWarning').removeClass('hide');
			return;
		} else {
			window.jQuery('#minGiftWarning').addClass('hide');
		}
		window.jQuery('#giftDollars').val(giftDollars);

		var regSubtotal = parseFloat(window.jQuery('#regTotal').data('price') || 0);
		var giftAmount = parseFloat(giftDollars);
		var grandTotal = regSubtotal + giftAmount;
		window.jQuery('#chargeAmount').val(grandTotal);
		window.jQuery('#grandTotal').html('$ ' + numeral(grandTotal).format(',9.99'));
		if (grandTotal > 0) {
			window.jQuery('.address-wrapper').removeClass('hide');
		} else {
			if (window.jQuery('.address-wrapper').data('collectaddress') === true) {
				window.jQuery('.address-wrapper').removeClass('hide');
			} else {
				window.jQuery('.address-wrapper').addClass('hide');
			}
		}

		module.exports.initGateway(grandTotal);
	},
	initGateway: (amount) => {
		window.jQuery('#gateway-container').empty();
		if (amount <= 0) {
			return;
		}
		paymentGateway.init({
			braintreeConfig: {
				containerId: '#gateway-container',
				submitBtnSelector: '.finalizeRegistration',
				venmo: {
					allowNewBrowserTab: true //set this to false in places where refreshing the page would break it (like a SPA)
				},
				paypal: {
					flow: 'vault'
				},
				applePay: {
					displayName: window.iq.customerName,
					paymentRequest: {
						total: {
							label: 'Registration Fees',
							amount: `${amount}` //yes, a string
						}
					}
				},
				googlePay: {
					transactionInfo: {
						totalPrice: `${amount}` //yes, a string
					}
				}
			},
			spreedlyConfig: {
				company_name: window.iq.customerName,
				sidebar_top_description: window.iq.eventName,
				sidebar_bottom_description: 'Your total today'
			}
		});
	},
	tokenizePayment: () => {
		paymentGateway.update({
			amountDisplay: '$' + window.jQuery('#chargeAmount').val(),
			fullName: window.iq.fullName,
			email: window.iq.emailAddress,
			street1: window.iq.address1,
			street2: window.iq.address2,
			city: window.iq.city,
			state: window.iq.state,
			postalCode: window.iq.postalCode,
			nation: window.iq.country
		});
		paymentGateway.tokenize();
	},
	validate: function validator() {
		var reEnableSubmit = window.jQuery('#regInvoice,#confInvoice').data('reenable');
		var totalCharge = window.jQuery('#chargeAmount').val();
		var giftAmount = parseFloat(window.jQuery('#giftDollars').val());

		if (giftAmount > 0) {
			if (giftAmount < window.iq.minGiftDollars) {
				//the error text can be overridden with a customer_string, so we'll just use whatever's in the box as our alert message
				window.alert(window.jQuery('#minGiftWarning').text().trim());
				reEnableSubmit();
				return false;
			}

			var selectedDesignationOption = window.jQuery('.giftDesignation').val();
			if (selectedDesignationOption === '') {
				window.alert('Thank you for your gift. Please indicate where we should direct it.');
				reEnableSubmit();
				return false;
			}
			if (selectedDesignationOption === 'other') {
				var otherDesignation = window.jQuery('#giftDesignation_other').val();
				if (otherDesignation === '') {
					window.alert('Thank you for your gift. Please indicate where we should direct it.');
					reEnableSubmit();
					return false;
				}
			}
		}

		if (totalCharge <= 0) {
			return true;
		}

		return true;
	}
};

function clearOtherDesignation() {
	window.jQuery('.otherDesignationSearch').addClass('hide');
	window.jQuery('#giftDesignation_other,.designationSearch').val('');
	window.jQuery('.otherDesignationFound').text('');
	window.jQuery('.otherDesignationFoundWrapper').addClass('hide');
}

function handleDesignationChange() {
	var $this = window.jQuery('.giftDesignation');
	if ($this.find('option:checked').data('other')) {
		window.jQuery('.otherDesignationSearch').removeClass('hide');
	} else {
		clearOtherDesignation();
	}
}

function searchDesignations(term, process) {
	window.jQuery
		.ajax({
			method: 'GET',
			url: '/api/v1/index.cfm/gift-designations?q=' + term
		})
		.done(function (data) {
			var clean = data.map(function (des) {
				return des.name;
			});
			process(clean);
		})
		.fail(function () {
			alert('There was an error processing your search. Please try again.');
		});
}

function setOtherDesignation(designation) {
	window.jQuery('#giftDesignation_other').val(designation);
	window.jQuery('.otherDesignationFound').text(designation);
	window.jQuery('.otherDesignationFoundWrapper').removeClass('hide');
	window.jQuery('.otherDesignationSearch').addClass('hide');
}

function updateAddress() {
	window.iq.address1 = window.jQuery('#address1').val();
	window.iq.address2 = window.jQuery('#address2').val();
	window.iq.city = window.jQuery('#city').val();
	window.iq.state = window.jQuery('#state').val();
	window.iq.postalCode = window.jQuery('#postalCode').val();
	window.iq.country = window.jQuery('#nation').val();
}
